module.exports = __webpack_public_path__ + "static/img/12-3.79f0e5e6.jpg";